class ProductMedia extends HTMLElement {
  constructor() {
    super()
    this.mainSwiper = null
    this.thumbsSwiper = null
    this.currentVariantId = new URLSearchParams(window.location.search).get(
      'variant'
    )
  }

  connectedCallback() {
    this.initSlider()
    this.initThumb()
    this.updateSwiperOnVariantChange()
    this.slideChange()
  }

  get mainSliderSelector() {
    return this.getAttribute('slider-selector')
  }

  get thumbsSliderSelector() {
    return this.getAttribute('thumbs-selector')
  }

  get sectionClass() {
    return this.getAttribute('section-class')
  }

  get sectionId() {
    return this.getAttribute('section-id')
  }

  initSlider() {
    const swiperEl = this.querySelector(
      `swiper-container${this.mainSliderSelector}`
    )

    const swiperParams = {
      direction: 'horizontal',
      slidesPerView: 1.15,
      pagination: {
        el: `.js-swiper-pagination--${this.sectionId}`,
        clickable: true,
      },
      breakpoints: {
        990: {
          pagination: false,
          slidesPerView: 1,
          direction: 'vertical',
        },
      },
      on: {
        slideChange: function (swiper) {
          swiper.slides = swiper.slides.filter(
            (slide) => !slide.classList.contains('hidden')
          )
        },
      },
    }

    Object.assign(swiperEl, swiperParams)
    swiperEl.initialize()
    this.mainSwiper = swiperEl.swiper
  }

  initThumb() {
    const swiperEl = this.querySelector(
      `swiper-container${this.thumbsSliderSelector}`
    )

    const swiperParams = {
      direction: 'vertical',
      spaceBetween: 16,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      slidesPerView: 'auto',
      centerInsufficientSlides: true,
      multipleActiveThumbs: false,
      on: {
        slideChange: function (swiper) {
          swiper.slides = swiper.slides.filter(
            (slide) => !slide.classList.contains('hidden')
          )
        },
      },
    }

    Object.assign(swiperEl, swiperParams)
    swiperEl.initialize()
    this.thumbsSwiper = swiperEl.swiper
  }

  updateSwiperOnVariantChange() {
    document.addEventListener('variant:change', (event) => {
      const selected = event.detail
      this.currentVariantId = selected.variant.id

      const selectedId = selected.variant.featured_media.id
      const selectedOption = selected.options

      var slideElement = document.getElementById('swiperSlide-' + selectedId)
      var slideThumbElement = document.getElementById(
        'swiperThumbSlide-' + selectedId
      )

      var visibleChildren = Array.from(
        slideElement.parentElement.children
      ).filter((child) => !child.classList.contains('hidden'))
      var slideIndex = visibleChildren.indexOf(slideElement)

      var visibleThumbChildren = Array.from(
        slideThumbElement.parentElement.children
      ).filter((child) => !child.classList.contains('hidden'))
      var slideThumbIndex = visibleThumbChildren.indexOf(slideThumbElement)

      if (this.mainSwiper || this.thumbsSwiper) {
        this.mainSwiper.slides.forEach((slide) => {
          if (slide.classList.contains('is_variant')) {
            slide.classList.add('hidden')
          }
        })

        this.thumbsSwiper.slides.forEach((slide) => {
          if (slide.classList.contains('is_variant')) {
            slide.classList.add('hidden')
          }
        })

        slideElement.classList.remove('hidden')
        slideThumbElement.classList.remove('hidden')

        this.mainSwiper.removeSlide(slideIndex)
        this.thumbsSwiper.removeSlide(slideThumbIndex)

        this.mainSwiper.prependSlide(slideElement)
        this.thumbsSwiper.prependSlide(slideThumbElement)

        this.mainSwiper.params.effect = 'fade'

        this.mainSwiper.update()

        this.mainSwiper.slideTo(0, 0)
        this.thumbsSwiper.slideTo(0)

        this.mainSwiper.params.effect = 'slide'
        this.mainSwiper.update()
      }

      if ( selectedOption.length ){
        const selectedInput = document.querySelector(`input[type="radio"][value="${selectedOption[0]}"`)
        selectedInput?.focus()
      }
    })
  }

  slideChange() {
    var thumbItems = document.querySelectorAll(
      '.media-gallery__slide-image-holder'
    )
    thumbItems.forEach((item, index) => {
      item.setAttribute('tabindex', '0')
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          const thumbIndex = event.target.parentNode.dataset.slideIndex
          this.mainSwiper.slideTo(thumbIndex)
          setTimeout(() => {
            event.target.focus()
          }, 350)
        }
      })
    })
  }

  resizeSwiper(swiperEl) {
    if (window.innerWidth < 768) {
      document.querySelectorAll('swiper-slide').forEach(function (slide) {
        slide.style.height = `${swiperEl.clientHeight}px`
      })
    }
  }
}

window.customElements.define('product-media', ProductMedia)
